import { createAction, props } from '@ngrx/store';
import {
  OrganizationReports,
  OrganizationReportsPayload,
} from 'src/app/admin/models/analytics.model';
import { AnalyticsApiError } from './analytics.errors';

export const LoadOrganizationReports = createAction(
  '[Analytics] Load Organization Reports',
  props<{ payload: OrganizationReportsPayload }>(),
);

export const SetOrganizationReports = createAction(
  '[Analytics] Set Organization Reports',
  props<{ organizationReports: OrganizationReports }>(),
);

export const SetOrganizationReportsError = createAction(
  '[Analytics] Set Organization Reports Error',
  props<{ error: AnalyticsApiError }>(),
);

export const RemoveAnalyticsError = createAction('[Analytics] Remove Error');
